import React from 'react'
import BaseComponent from "../pages/base/BaseComponent";
import {Button, Card, Col, Modal, Row} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import PropTypes from 'prop-types';
import {parseDate} from "enqc-utilities/src/utils/Utilities";
import {DD_MMMM_YYYY_HH_MM_SS} from "../utils/Global";
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import TextInput from "./input/TextInput";
import {faCode, faPlus, faStickyNote} from "@fortawesome/free-solid-svg-icons";
import TextAreaInput from "./input/TextAreaInput";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default class ModelDetailInformationModal extends BaseComponent{

    constructor(props) {
        super(props);
        let {model, show} = this.props
        if(!model){
            model = {}
        }
        this.state = {
            model:model?model:{},
            show:show
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let {model, show} = nextProps
            if(!model){
                model = {}
            }
            this.setState({model, show},() => {
                if(show){
                    // window.history.pushState({ show: true }, '');
                    this.handlePopState = (event) =>{
                        if (show) {
                            this.props.onClose()
                            // window.history.pushState(null, ''); // re-push state to prevent deep back
                            window.history.pushState({ show: true }, '');
                        }
                    }
                    window.addEventListener('popstate', this.handlePopState);
                }else{
                    window.removeEventListener('popstate', this.handlePopState);
                }
            })
        }
    }

    render() {
        let {enableCreateAssembly, onCreateAssembly} = this.props
        let {model,show} = this.state
        let {user} = model
        if(!user){
            user = {}
        }
        let {modelCategory} = model
        if(!modelCategory){
            modelCategory = {}
        }
        if(!onCreateAssembly){
            onCreateAssembly = () => {}
        }

        return (
            <>
                {super.render()}
                <Modal
                    as={Modal.Dialog}
                    size="xl"
                    centered
                    show={show}
                    onHide={()=>{}}>
                    <Modal.Header>
                        <Modal.Title className="h6">{label.ModelDetail}</Modal.Title>
                        <Button variant="close" aria-label="Close" onClick={()=>{
                            this.props.onClose()
                        }} />
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        <Row>
                            <Col md={3} className="d-none d-md-block mb-2">
                                <Row>
                                    <Col>
                                        <Card border="light" className=" text-center p-0 mb-4">
                                            <Card.Body className="p-0">
                                                <Card.Img
                                                    src={model.iconPhotoUrl?model.iconPhotoUrl:ApplicationIcons.Icons.cabinet}
                                                    alt={model.systemType}
                                                    className="rounded-0 rounded-top border-secondary mx-auto p-3" />
                                                <br/>
                                                <br/>
                                                <span>{label.Name}</span>
                                                <Card.Subtitle className="p-2">{model.modelName}</Card.Subtitle>
                                                <br/>
                                                <span>{label.SystemType}</span>
                                                <Card.Subtitle className="p-2">{model.systemType}</Card.Subtitle>
                                                <br/>
                                                <Card.Text className="text-gray p-2 text-small">{label.Updated} @{parseDate(model.updated, DD_MMMM_YYYY_HH_MM_SS)}</Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                                {enableCreateAssembly&&(
                                    <Row>
                                        <Col>
                                            <Button
                                                className="d-block w-100"
                                                size="sm"
                                                variant="success"
                                                onClick={e => {
                                                    e.preventDefault()
                                                    onCreateAssembly(model)
                                                }}>
                                                    <FontAwesomeIcon icon={faPlus} size="sm" />
                                                    &nbsp;
                                                    {label.CreateAssembly}
                                            </Button>
                                        </Col>
                                    </Row>
                                )}
                            </Col>
                            <Col md={9} className="text-left mb-2">
                                <Row>
                                    <Col md={6} sm={12}>
                                        <TextInput
                                            label={label.SystemType}
                                            icon={faCode}
                                            readOnly={true}
                                            value={model.systemType}
                                        />
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <TextInput
                                            label={label.PartName}
                                            icon={faCode}
                                            readOnly={true}
                                            value={model.partName}
                                        />
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <TextInput
                                            label={label.PartNumber}
                                            icon={faCode}
                                            readOnly={true}
                                            value={model.partNumber}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6} sm={12}>
                                        <TextInput
                                            label={label.ACInput}
                                            icon={faCode}
                                            readOnly={true}
                                            value={model.acInput}
                                        />
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <TextInput
                                            label={label.Frequency}
                                            icon={faCode}
                                            readOnly={true}
                                            value={model.frequency}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6} sm={12}>
                                        <TextInput
                                            label={label.ACInputCurrent}
                                            icon={faCode}
                                            readOnly={true}
                                            value={model.acInputCurrent}
                                        />
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <TextInput
                                            label={label.DCOutput}
                                            icon={faCode}
                                            readOnly={true}
                                            value={model.dcOutput}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6} sm={12}>
                                        <TextInput
                                            label={label.Polarity}
                                            icon={faCode}
                                            readOnly={true}
                                            value={model.polarity}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <TextAreaInput
                                            rows={5}
                                            label={label.Description}
                                            icon={faStickyNote}
                                            readOnly={true}
                                            value={model.description}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4} className="mb-3">
                                        <Card className="text-center card-equal-height">
                                            <Card.Body>
                                                <Row>
                                                    <Col>{label.ModelCategory}</Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <h4>{modelCategory.name}</h4>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col xs={6} md={4} className="mb-3">
                                        <Card className="text-center card-equal-height">
                                            <Card.Body>
                                                <Row>
                                                    <Col>{label.SerialComponent}</Col>
                                                </Row>
                                                <br/>
                                                <Row>
                                                    <Col>
                                                        <h2>{model.componentSize}</h2>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col xs={6} md={4} className="mb-3">
                                        <Card className="text-center card-equal-height">
                                            <Card.Body>
                                                <Row>
                                                    <Col>{label.RectifierController}</Col>
                                                </Row>
                                                <br/>
                                                <Row>
                                                    <Col>
                                                        <h2>{model.sizeOfRectifierControllerSerialNumber}</h2>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row className="d-block d-md-none d-sm-none d-xs-none">
                                    <Col>
                                        <Button
                                            className="d-block w-100"
                                            size="sm"
                                            variant="success"
                                            onClick={e => {
                                                e.preventDefault()
                                                onCreateAssembly(model)
                                            }}>
                                            <FontAwesomeIcon icon={faPlus} size="sm" />
                                            &nbsp;
                                            {label.CreateAssembly}
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            </>
        );
    }

}
ModelDetailInformationModal.propTypes = {
    model:PropTypes.object.isRequired,
    show:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired,
    enableCreateAssembly:PropTypes.bool,
    onCreateAssembly:PropTypes.func

}
